// AppraisalStepperForm/Step2SelfAppraisal.jsx
import { FormControlLabel, Checkbox, Switch, Typography, Grid, Box, Paper, Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';

const parameters = ['KRA', 'Goals', 'Skill', 'Will'];

const Step2SelfAppraisal = () => {
  const { values, setFieldValue } = useFormikContext();

  const toNormalCase = (str) => {
    if (!str) return '';
    return str
      .replace(/([A-Z])/g, ' $1') // Insert space before capital letters
      .replace(/^./, (char) => char.toUpperCase()); // Capitalize first letter
  };

  const handleSelectAll = (checked) => {
    parameters.forEach((param) => {
      setFieldValue(`selfAppraisal.parameters.${param}.included`, checked);
      setFieldValue(`selfAppraisal.parameters.${param}.ratings`, checked);
      setFieldValue(`selfAppraisal.parameters.${param}.comments`, checked);
      setFieldValue(`selfAppraisal.parameters.${param}.ratingsMandatory`, checked);
      setFieldValue(`selfAppraisal.parameters.${param}.commentsMandatory`, checked);
    });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Self Appraisal Parameters
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={parameters.every((param) => values.selfAppraisal.parameters[param].included)}
            onChange={(e) => handleSelectAll(e.target.checked)}
          />
        }
        label="Select All Parameters"
      />

      {/* -------------------------------------------------------- */}
      {parameters.map((param) => {
        return (
          <Paper
            sx={{
              backgroundColor: 'grey.200',
              mt: 2,
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography variant="subtitle1">{param}</Typography>
            <Box>
              <FormControlLabel
                control={
                  <Switch
                    checked={values.selfAppraisal.parameters[param].included}
                    onChange={(e) => setFieldValue(`selfAppraisal.parameters.${param}.included`, e.target.checked)}
                  />
                }
                label="Included"
              />
            </Box>
            <Box sx={{ p: 1 }}>
              {['ratings', 'comments', 'ratingsMandatory', 'commentsMandatory'].map((key) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={values.selfAppraisal.parameters[param].included ? false : true}
                      checked={values.selfAppraisal.parameters[param][key]}
                      onChange={(e) => setFieldValue(`selfAppraisal.parameters.${param}.${key}`, e.target.checked)}
                    />
                  }
                  label={toNormalCase(key)}
                />
              ))}
            </Box>
          </Paper>
        );
      })}
      {/* ---------------------------------------------------------------------- */}
      {/* {parameters.map((param) => (
        <Box key={param} mb={2}>
          <Typography variant="subtitle1">{param}</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={values.selfAppraisal.parameters[param].included}
                    onChange={(e) =>
                      setFieldValue(
                        `selfAppraisal.parameters.${param}.included`,
                        e.target.checked
                      )
                    }
                  />
                }
                label="Included"
              />
            </Grid>
            {[
              "ratingsMandatory",
              "commentsMandatory",
              "ratings",
              "comments",
            ].map((key) => (
              <Grid item xs={6} sm={3} key={key}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.selfAppraisal.parameters[param][key]}
                      onChange={(e) =>
                        setFieldValue(
                          `selfAppraisal.parameters.${param}.${key}`,
                          e.target.checked
                        )
                      }
                    />
                  }
                  label={key}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      ))} */}
    </Box>
  );
};

export default Step2SelfAppraisal;
